(function () {
  if (!window.theme?.settings?.prelaunchMode) return;

  function getContextFromTrigger(trigger) {
    if (!trigger) {
      return {
        productTitle: '',
        variantTitle: '',
        pageUrl: window.location.pathname,
      };
    }

    return {
      productTitle: trigger.dataset.productTitle || '',
      variantTitle: trigger.dataset.variantTitle || '',
      pageUrl: trigger.dataset.pageUrl || window.location.pathname,
      opener: trigger,
    };
  }

  function setLeadContext(context) {
    const modal = document.getElementById('modal-prelaunch-lead');
    if (!modal) return null;

    const productField = modal.querySelector('#PrelaunchLead-product');
    const variantField = modal.querySelector('#PrelaunchLead-variant');
    const urlField = modal.querySelector('#PrelaunchLead-url');

    if (productField) productField.value = context.productTitle || '';
    if (variantField) variantField.value = context.variantTitle || '';
    if (urlField) urlField.value = context.pageUrl || window.location.pathname;

    return modal;
  }

  window.openPrelaunchLeadModal = function openPrelaunchLeadModal(context = {}) {
    const modal = setLeadContext(context);
    if (!modal || typeof modal.show !== 'function') return;
    modal.show(context.opener || null);
  };

  function isCheckoutControl(element) {
    if (!element) return false;
    return Boolean(
      element.closest('.cart__checkout-button') ||
        element.closest('.shopify-payment-button') ||
        element.closest('.shopify-payment-button__button') ||
        element.closest('[data-shopify="payment-button"]') ||
        (element.getAttribute('name') === 'checkout' && !element.closest('#modal-prelaunch-lead'))
    );
  }

  function normalizeWhatsApp(value) {
    return String(value || '').replace(/\D/g, '');
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('.prelaunch-lead-trigger');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        openPrelaunchLeadModal(getContextFromTrigger(trigger));
        return;
      }

      const checkoutControl = event.target.closest('button, a, input');
      if (isCheckoutControl(checkoutControl)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openPrelaunchLeadModal({
          pageUrl: window.location.pathname,
          opener: checkoutControl,
        });
      }
    },
    true
  );

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.id === 'PrelaunchLeadForm') {
      const whatsappInput = form.querySelector('#PrelaunchLead-whatsapp');
      const digits = normalizeWhatsApp(whatsappInput?.value);
      if (digits.length < 10 || digits.length > 13) {
        event.preventDefault();
        whatsappInput?.setCustomValidity(window.prelaunchLeadStrings?.whatsappInvalid || 'Invalid WhatsApp');
        whatsappInput?.reportValidity();
        return;
      }
      whatsappInput?.setCustomValidity('');
      return;
    }

    if (form.matches('[data-type="add-to-cart-form"], #CartDrawer-Form, form[action*="/cart"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openPrelaunchLeadModal({ pageUrl: window.location.pathname });
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target?.id === 'cart-upsell-checkbox' && event.target.checked) {
      event.preventDefault();
      event.target.checked = false;
      openPrelaunchLeadModal({ pageUrl: window.location.pathname });
    }
  }, true);
})();
